<template>
<div class="orderMenuBox" :style="parent.checOutShow">
    <div class="stretch-box " :class="{open:parent.isChecOutOpen}" @mousedown="(e)=>{e.preventDefault()}">
        <div class="left-la-box verticalCenter" @click="parent.isChecOutOpen=false;"><i class="iconfont icon-fangxiangquan-left"></i></div>
        <div class="stretch-scroll-box">
            <div class="panel-heading">
                <div class="tr left-content">
                    <div class="td name">名称</div>
                    <div class="td tdnum">数量</div>
                    <div class="td tds">单价</div>
                    <div class="td subtotal">小计</div>
                    <button class="more-bnt"  @mousedown="(e)=>{e.stopPropagation()}" @click="parent.isChecOutOpen=!parent.isChecOutOpen;">
                        <i class="iconfont" :class="parent.isChecOutOpen?'icon-youla':'icon-zuola'" ></i>
                    </button> 
                </div>
                <div class="extend-right">
                    <div class="tr"> 
                        <div class="td" style="min-width:52px">折前单价</div>
                        <div class="td" style="min-width:35px">优惠</div>
                        <div class="td" style="min-width:60px">折前小计</div>
                        <div class="td" style="min-width:60px">辅助单位</div>
                        <div class="td" style="min-width:60px">达成率%</div>
                        <div class="td" style="min-width:40px">状态</div>
                        <div class="td" style="min-width:40px">下单</div>
                        <div class="td" style="min-width:80px">制作</div>
                        <div class="td" style="min-width:80px">划菜</div>
                        <div class="td" style="min-width:80px">上桌</div>
                    </div>
                </div>
            </div>
            <div class="scrollnot" :class="parent.isCheckOutclass"  v-mouse-scroll ref="box" v-scroll-anime="{up:'order-up',down:'order-down',liClass:'.slide-wrapper',paddingH:'25'}" >
                <div class="slide-wrapper" :class="oneLevelClass(item)" v-for="(item,index) in orderMenuFilter"  :key="item">
                    <div class="index">{{index+1}}</div>
                    <div class="animate-slide-start" >
                        <div class="slide-content flex-box" @click="radioClick(item)" :title="item.EAT_XFName" >
                            <div class="left-content" style="position: relative">
                                <div class="tr">
                                    <div class="td name nowrap"><i class="iconfont icon-tesecai" v-show="parent.sysSetting.RunOrderListShowSpecialFoodFlag && item.Is_Special"></i>{{item.EAT_XFName}}</div>
                                    <div class="td tdnum">{{item.Eat_Number}}</div>
                                    <div class="td tds">
                                        <template v-if="item.isPromotion2">¥{{Conversion(item.zkPromotionPrice)}}</template>
                                        <template v-else>¥{{Conversion(item.Eat_CheckPrice)}}</template>
                                        /{{(item.Eat_XFSize||"").substring(0,2)}}
                                    </div>
                                    <div class="td subtotal nowrap">
                                        <template v-if="item.isPromotion2">{{Conversion((item.zkPromotionPrice * item.Eat_Number))}}</template>
                                        <template v-else>{{Conversion((item.Eat_CheckPrice * item.Eat_Number))}}</template>
                                    </div>
                                </div>
                                <div class="describe flex-box">
                                    <div class="inlineBlock nowrap2 flavor">
                                        <span v-if="item.Eat_MasName" :title="item.Eat_MasName" @mousedown="(e)=>{e.stopPropagation()}" @click="radioClick(item);masClick()">
                                            <i class="iconfont icon-a-beizhu2" ></i>
                                            口味:<span>{{item.Eat_MasName}}</span>
                                        </span>
                                    </div>
                                    <div class="inlineBlock tag-box">
                                        
                                        <span class="tag pin" v-if="item.FoodProperty_Dimension=='拼' || (item.Food_Type==1 && item.Eat_TcAutoID_Batch && !item.Eat_TcName)">拼</span>
                                        <!--套-->
                                        <span class="tag tao" v-else-if="item.FoodProperty_Dimension" :style="{visibility:(item.FoodProperty_Dimension?'':'hidden')}" >{{item.FoodProperty_Dimension||'套'}}</span>
                                        <!--赠,折-->
                                        <span class="tag give" v-if="item.FoodDiscount_Dimension" :style="{visibility:(item.FoodDiscount_Dimension?'':'hidden')}" >{{item.FoodDiscount_Dimension||'无'}}</span>
                                        <span class="tag retreat" v-if="item.isPromotion2">第二份折扣</span>
                                        <!--厨房状态-->
                                        <span v-html="kitSpeedHtml(item.KitSpeed_Dimension,item.Food_Status)"></span>
                                        <!-- <span class="tag delimit" v-if="item.KitSpeed_Dimension" >{{item.KitSpeed_Dimension}}</span> -->
                                        <!--退菜-->
                                        <span class="tag retreat" v-if="item.Refund_Number>0">退{{item.Refund_Number}}</span>
                                        <span class="tag retreat" v-if="item.ChangeNum_Status==1">未</span>
                                    </div>
                                    <div class="more" v-if="(item.FoodSetmeals || item.OrderComboConsumes || item.Eat_TcItemList)?.length>0">
                                        <div class="more-bnt" v-if="moreConsumeID!=item.Eat_ConsumeID" @click="moreConsumeID=item.Eat_ConsumeID">
                                            <i class="iconfont icon-xiala"></i>
                                        </div>
                                        <div class="more-bnt" v-else @click="moreConsumeID=null">
                                            <i class="iconfont icon-shangla"></i>
                                        </div>
                                    </div>
                                    <div class="time-box nowrap" :style="{visibility:(item.Time_Notice?'':'hidden')}">
                                        <i class="time-icon"></i>
                                        <span>{{item.Time_Notice}}</span>
                                    </div>
                                </div>
                            </div> 
                            <div class="extend-right" v-show="parent.isChecOutOpen">
                                <div class="flex-box">
                                    <div class="td" style="min-width:52px"><span v-if="item.Eat_SalePrice" >{{Conversion(item.Eat_SalePrice)}}</span></div>
                                    <div class="td" style="min-width:35px">
                                        <span v-if="item.Eat_SalePrice && item.Eat_SaleMoney">{{Conversion(item.Eat_SaleMoney-item.Eat_CheckMoney)}}</span>
                                        <span v-else>0</span>
                                    </div>
                                    <div class="td" style="min-width:60px"><span v-if="item.Eat_SaleMoney">¥{{Conversion(item.Eat_SaleMoney)}}</span></div>
                                    <div class="td" style="min-width:60px">
                                        <span v-if="item.Eat_AssSize">{{item.Eat_AssNumber+'/'+item.Eat_AssSize}}</span>
                                        <span v-if="item.Food_AssSize">{{item.AssSizeNumber+'/'+item.Food_AssSize}}</span>
                                    </div>
                                    <div class="td" style="min-width:60px"><span v-if="item.CompleteRate">{{item.CompleteRate}}</span></div>
                                    <div class="td" style="min-width:40px">
                                        <div class="text" v-if="item.Food_Speed" >
                                            <p>{{item.Food_Speed}}</p>
                                            <p v-if="item.Food_Speed=='起菜'">{{new Date(item.Eat_UpTime).Format("hh:mm")}}</p>
                                        </div>
                                    </div>
                                    <div class="td" style="min-width:40px">
                                        <div class="text" v-if="item.Eat_Czy" >
                                            <p>{{item.Eat_Czy}}</p>
                                            <p>{{new Date(item.Eat_Time).Format("hh:mm")}}</p>
                                        </div>
                                    </div>
                                    <div class="td" style="min-width:80px">
                                        <div class="text" v-if="item.Cooker">
                                            <p>{{item.Cooker}}</p>
                                            <p>{{new Date(item.Cook_Time).Format("hh:mm")}}</p>
                                        </div>
                                    </div>
                                    <div class="td" style="min-width:80px">
                                        <div class="text" v-if="item.Crosser">
                                            <p>{{item.Crosser}}</p>
                                            <p>{{new Date(item.Cross_Time).Format("hh:mm")}}</p>
                                        </div>
                                    </div>
                                    <div class="td" style="min-width:80px">
                                        <div class="text" v-if="item.OnDesker">
                                            <p>{{item.OnDesker}}</p>
                                            <p>{{new Date(item.OnDesk_Time).Format("hh:mm")}}</p>
                                        </div>
                                        <div class="button" v-else>
                                            <div v-if="(!item.FoodSetmeals && !item.Mas_ParentID ) && item.Eat_Czy && parent.CheckONDesk" @click="parent.ConfirmOnDesk(parent.CheckONDesk,item);">
                                                {{parent.CheckONDesk?.ProjectItem_Name || parent.CheckONDesk?.ProjectSubItem_Name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="describe-more">
                                    <div class="td" style="min-width:52px"></div>
                                    <div class="td" style="min-width:215px;text-align: left;" :title="item.FoodOper_Note">
                                        <template v-if="item.Food_Status>=0">
                                            <span class="tag retreat" v-if="item.Refund_Number>0 && item.FoodOper_Note" >{{item.FoodOper_Note}}</span>
                                            <span class="tag give" v-else-if="item.FoodDiscount_Dimension && item.FoodOper_Note">{{item.FoodOper_Note}}</span>
                                        </template>
                                    </div>
                                    <div class="td" style="min-width:320px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border"></div>
                    <!--套餐滑出-->
                    <!--下单前-->
                    <el-collapse-transition>
                    <template v-if="item.FoodSetmeals?.length>0">
                    <div class="more-box" v-show="moreConsumeID==item.Eat_ConsumeID">
                        <div class="slide-content" :class="{selected:food.FoodSetmeal_ID == parent.disRadioOrder?.FoodSetmeal_ID && food.FoodSetmeal_Name== parent.disRadioOrder?.FoodSetmeal_Name}"  
                            :title="item.EAT_XFName" v-for="(food,foodindex) in item.FoodSetmeals" :key="foodindex" @click="parent.EatTcClick(food,foodindex,item)" >
                            <div class="flex-box">
                                <div class="left-content" style="position: relative">
                                    <div class="tr">
                                        <div class="td name nowrap">{{food.ReplaceFood_Name||food.FoodSetmeal_Name}}</div>
                                        <div class="td tdnum">{{food.FoodSetmeal_Number}}</div>
                                        <!--food.FoodSaleMoney+-->
                                        <div class="td tds" >¥{{Conversion(food.FoodSetmeal_Price)}}/{{(food?.FoodSetmeal_Size||"份").substring(0,1)}}</div>
                                        <div class="td subtotal nowrap" >{{Conversion((food.FoodSetmeal_Price) * food.FoodSetmeal_Number) }}</div>
                                    </div>
                                    <div class="describe flex-box">
                                        <div class="inlineBlock flavor nowrap2" >
                                            <span v-if="food.Eat_MasName" :title="food.Eat_MasName" @mousedown="(e)=>{e.stopPropagation()}" 
                                                @click="parent.EatTcClick(food,foodindex,item);masClick()">
                                                <i class="iconfont icon-a-beizhu2" ></i>
                                                口味:<span>{{food.Eat_MasName}}</span>
                                            </span>
                                        </div>
                                        <div class="inlineBlock tag-box">
                                            <span class="tag tao" style="visibility:hidden" >无</span>
                                            <!--套-->
                                            <!--赠,折-->
                                            <span class="tag give"  :style="{visibility:(food.FoodDiscount_Dimension?'':'hidden')}">{{food.FoodDiscount_Dimension||"无"}}</span>
                                            <!--厨房状态-->
                                            <span v-html="kitSpeedHtml(food.KitSpeed_Dimension,food.Food_Status)"></span>
                                            <!-- <span class="tag delimit" v-if="food.KitSpeed_Dimension">{{food.KitSpeed_Dimension}}</span> -->
                                        </div>
                                        <div class="more">&nbsp;&nbsp;</div>
                                        <div class="time-box nowrap" style="visibility:hidden">
                                            &nbsp;&nbsp;
                                        </div>
                                    </div> 
                                </div>
                                <div class="extend-right">
                                    <div class="flex-box">
                                        <div class="td" style="min-width:52px">
                                            <span v-if="food.Eat_SalePrice" >{{Conversion(food.Eat_SalePrice)}}</span>
                                            <span v-else>0</span>
                                        </div>
                                        <div class="td" style="min-width:35px">
                                            <span v-if="food.Eat_SalePrice && food.Eat_SaleMoney">{{Conversion(food.Eat_SaleMoney-food.Eat_CheckMoney)}}</span>
                                            <span v-else>0</span>
                                        </div>
                                        <div class="td" style="min-width:60px">
                                            <span v-if="food.Eat_SaleMoney">¥{{Conversion(food.Eat_SaleMoney)}}</span>
                                            <span v-else>0</span>
                                        </div>
                                        <div class="td" style="min-width:60px"><span v-if="food.Eat_AssSize">{{food.Eat_AssNumber+'/'+food.Eat_AssSize}}</span></div>
                                        <div class="td" style="min-width:60px"><span v-if="food.CompleteRate">{{food.CompleteRate}}</span></div>
                                        <div class="td" style="min-width:40px">
                                            <div class="text" v-if="item.Food_Speed" >
                                                <p>{{item.Food_Speed}}</p>
                                                <p v-if="item.Food_Speed=='起菜'">{{new Date(item.Eat_UpTime).Format("hh:mm")}}</p>
                                            </div>
                                        </div>
                                        <div class="td" style="min-width:40px">
                                            <div class="text" v-if="food.Eat_Czy" >
                                                <p>{{food.Eat_Czy}}</p>
                                                <p>{{new Date(food.Eat_Time).Format("hh:mm")}}</p>
                                            </div>
                                        </div>
                                        <div class="td" style="min-width:80px">
                                            <div class="text" v-if="food.Cooker">
                                                <p>{{food.Cooker}}</p>
                                                <p>{{new Date(food.Cook_Time).Format("hh:mm")}}</p>
                                            </div>
                                        </div>
                                        <div class="td" style="min-width:80px">
                                            <div class="text" v-if="food.Crosser">
                                                <p>{{food.Crosser}}</p>
                                                <p>{{new Date(food.Cross_Time).Format("hh:mm")}}</p>
                                            </div>
                                        </div>
                                        <div class="td" style="min-width:80px">
                                            <div class="text" v-if="food.OnDesker">
                                                <p>{{food.OnDesker}}</p>
                                                <p>{{new Date(food.OnDesk_Time).Format("hh:mm")}}</p>
                                            </div>
                                            <div class="button" v-else>
                                                <div v-if="item.Eat_Czy&&!item.Mas_ParentID&&parent.CheckONDesk" @click="ConfirmOnDesk(parent.CheckONDesk,food);">
                                                    {{parent.CheckONDesk?.ProjectItem_Name || parent.CheckONDesk?.ProjectSubItem_Name}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                    <template v-else-if="item.OrderComboConsumes?.length>0">
                        <div class="more-box" v-show="moreConsumeID==item.Eat_ConsumeID">
                            <div class="slide-content" :class="{selected:parent.disRadioOrder.Is_Combo && food.Eat_ConsumeID == parent.disRadioOrder?.Eat_ConsumeID}"
                                :title="food.EAT_XFName" v-for="(food,foodindex) in item.OrderComboConsumes" :key="foodindex" 
                                @click="radioClick(food)">
                                <div class="flex-box">
                                    <div class="left-content" style="position: relative">
                                        <div class="tr">
                                            <div class="td name nowrap">{{food.EAT_XFName}}</div>
                                            <div class="td tdnum">{{food.Eat_Number}}</div>
                                            <!--food.FoodSaleMoney+-->
                                            <div class="td tds" >¥{{Conversion(food.Eat_CheckPrice)}}/{{(food?.Eat_XFSize||"份").substring(0,1)}}</div>
                                            <div class="td subtotal nowrap" >{{Conversion((food.Eat_CheckPrice) * food.Eat_Number) }}</div>
                                        </div>
                                        <div class="describe flex-box">
                                            <div class="inlineBlock flavor nowrap2" >
                                                <span v-if="food.Eat_MasName" :title="food.Eat_MasName" @mousedown="(e)=>{e.stopPropagation()}" 
                                                    @click="radioClick(food);masClick()">
                                                    <i class="iconfont icon-a-beizhu2" ></i>
                                                    口味:<span>{{food.Eat_MasName}}</span>
                                                </span>
                                            </div>
                                            <div class="inlineBlock tag-box">
                                                <span class="tag tao" style="visibility:hidden" >无</span>
                                                <!--套-->
                                                <!--赠,折-->
                                                <span class="tag give"  :style="{visibility:(food.FoodDiscount_Dimension?'':'hidden')}">{{food.FoodDiscount_Dimension||"无"}}</span>
                                                <!--厨房状态-->
                                                <span v-html="kitSpeedHtml(food.KitSpeed_Dimension,food.Food_Status)"></span>
                                                <!-- <span class="tag delimit" v-if="food.KitSpeed_Dimension">{{food.KitSpeed_Dimension}}</span> -->
                                            </div>
                                            <div class="more">&nbsp;&nbsp;</div>
                                            <div class="time-box nowrap" style="visibility:hidden">
                                                &nbsp;&nbsp;
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="extend-right">
                                        <div class="flex-box">
                                            <div class="td" style="min-width:52px">
                                                <span v-if="food.Eat_SalePrice" >{{Conversion(food.Eat_SalePrice)}}</span>
                                                <span v-else>0</span>
                                            </div>
                                            <div class="td" style="min-width:35px">
                                                <span v-if="food.Eat_SalePrice && food.Eat_SaleMoney">{{Conversion(food.Eat_SaleMoney-food.Eat_CheckMoney)}}</span>
                                                <span v-else>0</span>
                                            </div>
                                            <div class="td" style="min-width:60px">
                                                <span v-if="food.Eat_SaleMoney">¥{{Conversion(food.Eat_SaleMoney)}}</span>
                                                <span v-else>0</span>
                                            </div>
                                            <div class="td" style="min-width:60px"><span v-if="food.Eat_AssSize">{{food.Eat_AssNumber+'/'+food.Eat_AssSize}}</span></div>
                                            <div class="td" style="min-width:60px"><span v-if="food.CompleteRate">{{food.CompleteRate}}</span></div>
                                            <div class="td" style="min-width:40px">
                                                <div class="text" v-if="food.Food_Speed" >
                                                    <p>{{food.Food_Speed}}</p>
                                                    <p v-if="food.Food_Speed=='起菜'">{{new Date(food.Eat_UpTime).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:40px">
                                                <div class="text" v-if="food.Eat_Czy" >
                                                    <p>{{food.Eat_Czy}}</p>
                                                    <p>{{new Date(food.Eat_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.Cooker">
                                                    <p>{{food.Cooker}}</p>
                                                    <p>{{new Date(food.Cook_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.Crosser">
                                                    <p>{{food.Crosser}}</p>
                                                    <p>{{new Date(food.Cross_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.OnDesker">
                                                    <p>{{food.OnDesker}}</p>
                                                    <p>{{new Date(food.OnDesk_Time).Format("hh:mm")}}</p>
                                                </div>
                                                <div class="button" v-else>
                                                    <div v-if="item.Eat_Czy&&!item.Mas_ParentID&&parent.CheckONDesk" @click="parent.ConfirmOnDesk(parent.CheckONDesk,food);">
                                                        {{parent.CheckONDesk?.ProjectItem_Name || parent.CheckONDesk?.ProjectSubItem_Name}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="describe-more">
                                            <div class="td" style="min-width:52px"></div>
                                            <div class="td" style="min-width:215px;text-align: left;" :title="item.FoodOper_Note">
                                                <template v-if="food.Food_Status>=0">
                                                    <span class="tag retreat" v-if="food.Refund_Number>0 && food.FoodOper_Note">{{food.FoodOper_Note}}</span>
                                                    <span class="tag give" v-else-if="food.FoodDiscount_Dimension && food.FoodOper_Note">{{food.FoodOper_Note}}</span>
                                                </template>
                                            </div>
                                            <div class="td" style="min-width:320px"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    </el-collapse-transition>
                    <!--下单后-->
                    <el-collapse-transition>
                    <template v-if="item.Eat_TcItemList?.length>0">
                        <div class="more-box" v-show="moreConsumeID==item.Eat_ConsumeID">
                            <div class="slide-content" :class="{selected:food.Eat_ConsumeID == parent.disRadioOrder?.Eat_ConsumeID && food.EAT_XFName == parent.disRadioOrder?.EAT_XFName}"   
                                style="position: relative;" v-for="(food,foodindex) in item.Eat_TcItemList" :key="foodindex" 
                                @click="parent.EatTcClick(food,foodindex,item)" >
                                <div class="flex-box">
                                    <div class="left-content" style="position: relative">
                                        <div class="tr">
                                            <div class="td name nowrap2" :title="item.EAT_XFName" >{{food.EAT_XFName}}</div>
                                            <div class="td tdnum">{{food.Eat_Number}}</div>
                                            <div class="td tds">¥{{Conversion(food.Eat_CheckPrice)}}/{{(food.Eat_XFSize||"").substring(0,1)}}</div>
                                            <div class="td subtotal">{{Conversion(food.Eat_CheckPrice * food.Eat_Number)}}</div>
                                        </div>
                                        <div class="describe flex-box">
                                            <div class="inlineBlock flavor nowrap2">
                                                <span v-if="food.Eat_MasName" :title="food.Eat_MasName" @mousedown="(e)=>{e.stopPropagation()}" 
                                                    @click="parent.EatTcClick(food,foodindex,item);masClick()">
                                                    <i class="iconfont icon-a-beizhu2"></i>
                                                    口味:<span>{{food.Eat_MasName}}</span>
                                                </span>
                                            </div>
                                            <div class="inlineBlock tag-box">
                                                <span class="tag tao" style="visibility:hidden" >无</span>
                                                <!--套-->
                                                <!-- <span class="tag tao" v-if="item.FoodProperty_Dimension" >{{item.FoodProperty_Dimension}}</span> -->
                                                <!--赠,折-->
                                                <span class="tag give"  :style="{visibility:(food.FoodDiscount_Dimension?'':'hidden')}">{{food.FoodDiscount_Dimension||"无"}}</span>
                                                <!--厨房状态-->
                                                <span v-html="kitSpeedHtml(food.KitSpeed_Dimension,food.Food_Status)"></span>
                                                <!-- <span class="tag delimit" v-if="food.KitSpeed_Dimension">{{food.KitSpeed_Dimension}}</span> -->
                                                <!--退菜-->
                                                <span class="tag retreat" v-if="food.Refund_Number>0">退{{food.Refund_Number}}</span>
                                            </div>
                                            <div class="more">&nbsp;&nbsp;</div>
                                            <div class="time-box nowrap" :style="{visibility:(food.Time_Notice?'':'hidden')}" >
                                                <i class="time-icon"></i>
                                                <span>{{food.Time_Notice}}</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="extend-right">
                                        <div class="flex-box">
                                            <div class="td" style="min-width:52px">
                                                <span v-if="food.Eat_SalePrice" >{{Conversion(food.Eat_SalePrice)}}</span>
                                                <span v-else>0</span>
                                                </div>
                                            <div class="td" style="min-width:35px">
                                                <span v-if="food.Eat_SalePrice && food.Eat_SaleMoney">{{Conversion(food.Eat_SaleMoney-food.Eat_CheckMoney)}}</span>
                                                <span v-else>0</span>
                                            </div>
                                            <div class="td" style="min-width:60px">
                                                <span v-if="food.Eat_SaleMoney">¥{{Conversion(food.Eat_SaleMoney)}}</span>
                                                <span v-else>0</span>
                                            </div>
                                            <div class="td" style="min-width:60px"><span v-if="food.Eat_AssSize">{{food.Eat_AssNumber+'/'+food.Eat_AssSize}}</span></div>
                                            <div class="td" style="min-width:60px"><span v-if="food.CompleteRate">{{food.CompleteRate}}</span></div>
                                            <div class="td" style="min-width:40px">
                                                <div class="text" v-if="item.Food_Speed" >
                                                    <p>{{item.Food_Speed}}</p>
                                                    <p v-if="item.Food_Speed=='起菜'">{{new Date(item.Eat_UpTime).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:40px">
                                                <div class="text" v-if="food.Eat_Czy" >
                                                    <p>{{food.Eat_Czy}}</p>
                                                    <p>{{new Date(food.Eat_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.Cooker">
                                                    <p>{{food.Cooker}}</p>
                                                    <p>{{new Date(food.Cook_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.Crosser">
                                                    <p>{{food.Crosser}}</p>
                                                    <p>{{new Date(food.Cross_Time).Format("hh:mm")}}</p>
                                                </div>
                                            </div>
                                            <div class="td" style="min-width:80px">
                                                <div class="text" v-if="food.OnDesker">
                                                    <p>{{food.OnDesker}}</p>
                                                    <p>{{new Date(food.OnDesk_Time).Format("hh:mm")}}</p>
                                                </div>
                                                <div class="button" v-else>
                                                    <div v-if="item.Eat_Czy&&!item.Mas_ParentID&&parent.CheckONDesk" @click="parent.ConfirmOnDesk(parent.CheckONDesk,food);">
                                                        {{parent.CheckONDesk?.ProjectItem_Name || parent.CheckONDesk?.ProjectSubItem_Name}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="describe-more">
                                            <div class="td" style="min-width:52px"></div>
                                            <div class="td" style="min-width:215px;text-align: left;" :title="item.FoodOper_Note">
                                                <span class="tag retreat" v-if="food.Refund_Number>0 && food.FoodOper_Note">{{food.FoodOper_Note}}</span>
                                                <span class="tag give" v-else-if="food.FoodDiscount_Dimension && food.FoodOper_Note">{{food.FoodOper_Note}}</span>
                                            </div>
                                            <div class="td" style="min-width:320px"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    </el-collapse-transition>
                </div>
            </div>
            <div class="reserve_Info nowrap" v-if="parent.isChecOutOpen && orderInfo.Reserve_Info">{{orderInfo.Reserve_Info}}</div>
        </div>
    </div>
    <div v-show="false" ref="order-up"></div>
    <div v-show="false" ref="order-down"></div>
    <div class="promotionalOffer-box" v-show="isCheckProm">
        <div class="text">本次点餐可以参与营销活动享受优惠</div>
        <div class="promotionalBnt" @click="clickPromotional">参与优惠</div>
    </div>
    <weighing v-model="parent.wgNum"></weighing>
    <!-- 参与活动选择 -->
    <modal-load :isShow="promotionalSelectShow" isUnload>
        <promotional-select-model :modalList="parent.$refs.modalList"  
            :isShow="promotionalSelectShow" :data="promotionalData" :promAutoid="promInfo?.PromAutoid"
            @confirm="confirmProm" @cancel="cancelProm"
            @close="promotionalSelectShow=false"/>
    </modal-load>
    <!-- 参与活动选择 -->
    <modal-load :isShow="promotionalGiveShow" isUnload>
        <promotional-give-model :modalList="parent.$refs.modalList" :maxGitNum="promMaxGitNum"
            :isShow="promotionalGiveShow" :data="promInfo" :allFoods="parent.allLinkFoods"
            @confirm="confirmPromGive" @cancel="cancelPromGive"/>
    </modal-load>
</div>
</template>

<script>
import { animation,newGuid,deepClone } from '/src/common' 
import { promotionalSelectModel,promotionalGiveModel } from './index'
//订单展示
export default {
    name:"orderMenuBox",
    components:{
        promotionalSelectModel,
        promotionalGiveModel
    },
    props:{
    },
    computed:{
        //父级
        parent(){
            return this.$parent;
        },
        //订单信息
        orderInfo(){
            return this.parent.orderInfo||{};
        },
        //订单过滤后的显示数据
        orderMenuFilter(){
            //组合套餐
            let comboList={};

            let list=[];
            this.parent.orderMenuList?.forEach((it,index)=>{
                it._orderIndex=index;//标记排序号
                if(it.Food_Status==-1 && it.Food_Type==1 && it.Eat_TcAutoID_Batch && !it.Eat_TcName && it.Eat_TcIndex>1){
                    it.Is_Combo=true;
                    if(comboList[it.Eat_TcAutoID_Batch]){
                        comboList[it.Eat_TcAutoID_Batch].push(it);
                    }else{
                        comboList[it.Eat_TcAutoID_Batch]=[it];
                    }
                }else{
                    list.push(it);
                }
            })
            list.forEach(it=>{
                if(comboList[it.Eat_TcAutoID_Batch]){
                    it.OrderComboConsumes=comboList[it.Eat_TcAutoID_Batch];
                }
            })
            return list;
        },
        //满减活动方案
        fullPomotionList(){
            return this.promotionList?.filter(it=>it.ScenList?.some(item=>item.Name=="POS堂食") && it.PromotionType==1)||[];
        },
        //副屏数据
        auxiliaryData(){
            if(this.parent.isCheckOut){//去付款
                let data={};
                if(this.parent.orderInfo){//订单信息
                    let orderInfo=this.parent.orderInfo;
                    data.Eat_DeskName=orderInfo.Eat_DeskName;//桌号
                    data.Eat_SaleMoney=Number(Number(orderInfo.Eat_SaleMoney).toFixed(2));//消费总额
                    data.Eat_ID=orderInfo.Eat_ID;//开单号
                    data.Service_Money=Number(Number(orderInfo.Service_Money).compute(this.parent.unionServiceMoney).toFixed(2));//服务费
                    data.Gift_Money=Number(Number(orderInfo.Gift_Money).compute(this.parent.unionGiftMoney).toFixed(2));// 赠送金额
                    data.ZK_Money=Number(Number(orderInfo.ZK_Money).compute(this.parent.unionZKMoney).toFixed(2));// 折扣金额
                    data.discountMoney=Number(Number(data.Gift_Money).compute(data.ZK_Money).toFixed(2));//优惠金额
                    data.Payable_Money=Number(Number(orderInfo.Payable_Money).toFixed(2));//应付金额
                }
                //显示 账单
                return data;
            }
            return null;
        },
        /**计算合计 */
        orderTotal(){
            let countNumber=0;
            let totalMoney=0;
            let sumMoney=0;//总金额
            //未下单菜品
            this.parent.orderMenuList?.filter(food=>food.Food_Status==-1)?.forEach(order=>{
                totalMoney += Number(Number(order.Eat_CheckPrice * Number(order.Eat_Number)))
                sumMoney+=Number(order.Eat_SalePrice||0) * Number(order.Eat_Number||0);
                countNumber += Number(order.Eat_Number);
                if(order?.FoodSetmeals){
                    order.FoodSetmeals.forEach(food=>{
                        totalMoney += Number(Number(Number(food.FoodSetmeal_Price) * Number(food.FoodSetmeal_Number)));
                        sumMoney+=Number(Number(Number(food.FoodSetmeal_Price) * Number(food.FoodSetmeal_Number)));
                        countNumber += Number(food.FoodSetmeal_Number);
                    })
                }
            })
            return {
                countNumber:countNumber,
                totalMoney:Number(totalMoney.toFixed(2)),
                sumMoney:Number(sumMoney.toFixed(2))
            };
        },
        //满减 金额
        fullReductionMoney(){
            if(this.foodNotOrdered?.length>0){
                return this.fullReduction();
            }
            return 0;
        },
        /**购物车 筛选 未下单的 */
        foodNotOrdered(){
            return this.parent.orderMenuList?.filter(food=>food.Food_Status==-1)||[];
        },
        /**未下单的 未赠送的 未折扣的 非加价口味的菜品数据 */
        foodNotOrderedNoDiscount(){
            //未下单的 未赠送的 未折扣的 菜品数据
            return this.parent.orderMenuList?.filter(food=>food.Food_Status==-1 && !food.is_taste && !food.Is_Gift && food.Eat_SalePrice==food.Eat_CheckPrice)||[];
        },
        /**当前满赠活动最多可赠送数量 */
        promMaxGitNum(){
            //选择的是满赠活动时 并且在适配的优化活动方案内
            if(this.promInfo?.PromotionType==3 && this.promInfo.MoneyGiftPromotion && this.promList?.some(it=>it.PromAutoid==this.promInfo.PromAutoid)){
                //活动方案
                let {
                    PromKindType,//类型
                    NeedOrderInNum,//满足份数或金额
                    GiftNum,//可赠送份数
                    RuleFoods//活动菜
                }=this.promInfo.MoneyGiftPromotion;
                //必须是未下单的 未赠送的 未折扣的 菜品数据
                let foods=this.foodNotOrderedNoDiscount;

                if(RuleFoods.length>0){
                    let totalNum=0,totalMoney=0;
                    foods.forEach(item=>{
                        if(RuleFoods.some(rule=>rule.Item_ID==item.EAT_XFBMID)){//
                            totalNum=Number(item.Eat_Number).compute(totalNum);//份数
                            totalMoney=Number(item.Eat_CheckPrice * item.Eat_Number).compute(totalMoney);//金额
                        }
                    })
                    totalMoney=Number(totalMoney.toFixed(2));
                    
                    if(PromKindType==1 || PromKindType==2){//满足 份数
                        if(totalNum>=NeedOrderInNum){
                            if(PromKindType==1){
                                return GiftNum;
                            }else{
                                return parseInt(totalNum/NeedOrderInNum)*GiftNum;
                            }
                        }
                    }else if(PromKindType==3 || PromKindType==4){//满足 金额
                        if(totalMoney>=NeedOrderInNum){
                            if(PromKindType==3){
                                return GiftNum;
                            }else{
                                return parseInt(totalMoney/NeedOrderInNum)*GiftNum;
                            }
                        }
                    }
                }
            }
            return 0;
        },
        //优惠活动方案
        promList(){
            //必须是未下单的 未赠送的 未折扣的 菜品数据
            let foods=this.foodNotOrderedNoDiscount;
            if(foods.length==0 || (this.promotionList||[]).length==0){
                return [];
            }
            let toDay=new Date();//当前时间
            let time=toDay.Format("hh:mm");//时分
            let weekDay=toDay.getDay();//周
            let day=toDay.Format('yyyy-MM-dd');//当前日期
            if(weekDay==0){
                weekDay=7;
            }
            
            return this.promotionList?.filter(it=>
                it.ScenList?.some(item=>item.Name=="POS堂食") &&
                it.BeginDate<=day && it.EndDate>=day && it.BeginTime<=time && it.EndTime>=time && it.WeekDay?.indexOf(weekDay)>=0
            )?.filter(it=>{
                if(it.PromotionType==2){//第二份优惠
                    let zkPromotion=it.SecondZkPromotion;//活动方案
                    if(zkPromotion){
                        let orderMenuList=(foods).filter(item=>item.Eat_Number>=1);
                        if(zkPromotion.PromKindType==1){//按活动菜品范围打折 要求是同一种菜品
                            if(zkPromotion.XfbmKind==1){//按菜品小类
                                //有符合条件的数据
                                
                                return zkPromotion.SubFoodKinds?.some(kind=>{
                                    let totalGroup={};
                                    return orderMenuList.filter(item=>item.SubCategory_ID==kind.Item_ID).some(item=>{
                                        if(totalGroup[item.EAT_XFBMID]==undefined){
                                            totalGroup[item.EAT_XFBMID]=0;
                                        }
                                        totalGroup[item.EAT_XFBMID]=parseInt(item.Eat_Number)+totalGroup[item.EAT_XFBMID];
                                        if(totalGroup[item.EAT_XFBMID]>=2){
                                            return true;
                                        }
                                    });
                                    
                                });                            
                            }else{/// =2 按菜品指定
                                //有符合条件的数据
                                
                                return zkPromotion.Foods?.some(kind=>{
                                    let count=0;//
                                    orderMenuList.forEach(item=>{
                                        if(item.EAT_XFBMID==kind.Item_ID){
                                            count=parseInt(item.Eat_Number)+count;
                                        }
                                    });
                                    return count>=2;//至少有一个活动菜一个折扣菜
                                });
                            }
                        }else{
                            
                            // let isPromItem=false;//是否有满足活动的菜
                            return orderMenuList.some(item=>{
                                if(zkPromotion.XfbmKind==1){//按菜品小类
                                    //有符合条件的数据
                                    if(!zkPromotion.SubFoodKinds?.some(kind=>item.SubCategory_ID==kind.Item_ID)){
                                        return false;
                                    }
                                }else{/// =2 按菜品指定
                                    //有符合条件的数据
                                    if(!zkPromotion.Foods?.some(kind=>item.EAT_XFBMID==kind.Item_ID)){
                                        return false;
                                    }
                                }
                                return orderMenuList.some(mItem=>
                                    zkPromotion.SpecifyFoods.some(kind=>kind.Item_ID==mItem.EAT_XFBMID &&
                                    (
                                        (mItem.Eat_ConsumeID==item.Eat_ConsumeID && mItem.Eat_Number>=2)) || //可折扣才 与 活动菜 指的是同一个 判断数量 
                                        (mItem.Eat_ConsumeID!=item.Eat_ConsumeID && mItem.Eat_Number>=1) //可折扣菜 数量
                                    )
                                );
                            })
                        }
                        
                    }
                }else if(it.PromotionType==3){//满赠活动
                    if(it.MoneyGiftPromotion){
                        let RuleFoods=it.MoneyGiftPromotion.RuleFoods||[];//活动菜范围
                        if(RuleFoods.length>0){
                            let totalNum=0,totalMoney=0;
                            foods.forEach(item=>{
                                if(item.Eat_Number>=1 && RuleFoods.some(rule=>rule.Item_ID==item.EAT_XFBMID)){//
                                    totalNum=Number(item.Eat_Number).compute(totalNum);//份数
                                    totalMoney=Number(item.Eat_CheckPrice * item.Eat_Number).compute(totalMoney);//金额
                                }
                            })
                            totalMoney=Number(totalMoney.toFixed(2));
                            if(it.MoneyGiftPromotion.PromKindType==1 || it.MoneyGiftPromotion.PromKindType==2){//满足 份数
                                if(totalNum>=it.MoneyGiftPromotion.NeedOrderInNum){
                                    return true;
                                }
                            }else if(it.MoneyGiftPromotion.PromKindType==3 || it.MoneyGiftPromotion.PromKindType==4){//满足 金额
                                if(totalMoney>=it.MoneyGiftPromotion.NeedOrderInNum){
                                    return true;
                                }
                            }
                        }
                    }
                }
            })
        },
        /**是否有满足 优惠条件的方案 */
        isCheckProm(){
            if(this.promList?.length>0){
                return true;
            }
            return false;
        }
    },
    data(){
        return {
            /*点菜单 列表是否展开 */
            isChecOutOpen:false,
            //记录 更多 打开的id
            moreConsumeID:null,
            //活动方案
            promotionList:null,
            /**参与活动选择 弹层 */
            promotionalSelectShow:false,
            /**可参与的活动 数据 */
            promotionalData:[],
            /**当前参加的优惠活动 
             * {
             * 当前活动赠送的菜品
             *  promGiveItems:null
             * }
            */
            promInfo:null,
            /**参与活动 满赠 弹层 */
            promotionalGiveShow:false,
            
        }
    },
    watch:{
        //订单信息变动
        auxiliaryData(){
            if(this.parent.isCheckOut){//去付款
                //显示 账单
                this.$webBrowser.openAuxiliaryScreen({orderInfo:this.auxiliaryData,showType:2});
            }else{
                this.$webBrowser.openAuxiliaryScreen({orderInfo:null,showType:0});
            }
        },
        orderTotal(){
            this.promotions();
        },
        /**当前满赠最多可赠送数量 变化了 */
        promMaxGitNum(){
            if(this.promInfo){
                this.setPromMaxGitNum();
            }
        },
        isCheckProm(){
            if(this.isCheckProm){
                this.setPromMaxGitNum();
            }
        }
    },
    mounted(){
        /**活动方案 */
        this.$cacheData.OnlinePromotions().then((d)=>{
            this.promotionList=d;
            console.log(d)
        }).catch(e=>{
            console.log(e)
            this.$alert("活动方案数据获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
    },
    methods:{
        //一级分类 类名
        oneLevelClass(item){
            let className=[];
            if(item.Food_Status>=0){
                className.push("selected");
            }

            if(this.parent.disRadioclass>=0){
                let trItem=this.parent.orderMenuList[this.parent.disRadioclass];
                if(this.parent.disRadioclass==item._orderIndex || (trItem && trItem.Is_Combo && item.OrderComboConsumes?.some(it=>it.Eat_ConsumeID==trItem.Eat_ConsumeID))){
                    className.push("selectedRow");
                }
            }
            
            return className;
        },
        //菜单选择菜品
        radioClick(item){
            this.$parent.radioClick(item._orderIndex,item);
        },
        //点击口味
        masClick(){
            this.$parent.MiddleMenuClick(this.$parent.userMiddleMenu?.find(d=>d.ProjectItem_Key=='Mas'))
        },
        //没有小数点显示整数,有小数位 显示两位小数
        Conversion(num){
            if(parseFloat(num)===parseInt(num)){
                return parseInt(num);
            }else{
                return Number(num).toFixed(2);
            }
        },
        /**更新标记 */
        updateRadio(){
            let disRadioOrder=this.parent.disRadioOrder;//当前选中的明细
            if(disRadioOrder){
                this.parent.orderMenuList.some((it,index)=>{
                    if(it.Eat_ConsumeID==disRadioOrder.Eat_ConsumeID){
                        this.$parent.radioClick(index,it);//点击菜品
                    }else if(it.FoodSetmeals){
                        return it.FoodSetmeals.some((fd,foodindex)=>{
                            if(fd.Eat_ConsumeID==disRadioOrder.Eat_ConsumeID){
                                this.parent.EatTcClick(fd,foodindex,it);//点击套餐明细菜品
                            }
                        })
                    }
                    return false;
                })
            }
        },
        /** 厨房状态 标签 显示htnl
         * @param KitSpeed_Dimension 厨房速度维度 ： 即，等，起，催，划
         * @param Food_Status 划菜状态，0：待切配 ，1：已切配 待制作， 2：已制作 待划菜， 3：已划菜 待上桌 ，4：已上桌
        */
        kitSpeedHtml(KitSpeed_Dimension,Food_Status){
            //已上桌 状态 优先于其他厨房速度维度
            if(Food_Status==4){
                return "<span class='tag img'><img src='/images/served.png'/></span>";
            }else if(Food_Status==1){
                return "<span class='tag img2'><img src='/images/yiqiepei.png'/></span>";
            }else if(Food_Status==2){
                return "<span class='tag img2'><img src='/images/yizhizuo.png'/></span>";
            }else if(KitSpeed_Dimension=="划"){
                return "<span class='tag iconfont icon-yihuacai'></span>";
            }else if(KitSpeed_Dimension=="即"){
                return "<span class='tag tagJi'>即</span>";
            }else if(KitSpeed_Dimension=="等"){
                return "<span class='tag tagDeng'>等</span>";
            }else if(KitSpeed_Dimension=="起"){
                return "<span class='tag tagQi'>起</span>";
            }else if(KitSpeed_Dimension=="催"){
                return "<span class='tag tagCui'>催</span>";
            }else if(KitSpeed_Dimension){
                return '<span class="tag delimit">'+KitSpeed_Dimension+'</span>'
            }   
        },
        pageUp(){
            this.$refs['order-up'].dispatchEvent(new Event("click"));
        },
        pageDown(){
            this.$refs['order-down'].dispatchEvent(new Event("click"));
        },
        /**滚动到 选中位置 */
        scrollRow(){
            animation.scrollTopAnchor(this.$refs.box,".slide-wrapper.selectedRow")
        },
        /**滚动到 底部*/
        scrollBottom(){
             /**自动滚动到最底部 */
            let _box = this.$refs.box;
            setTimeout(()=>{_box.scrollTop = _box.scrollHeight;},0)
        },
        /**清除 第二份折扣活动的标记 */
        clearProm2ZK(){
            this.foodNotOrdered?.forEach(it=>{
                //是否第二份 折扣
                it.isPromotion2=false;
                it.zkPromotionPrice=0;
                it._promotionNumber=0;//记录 原活动菜品 已经使用了几次 折扣
            });
        },
        /**计算促销活动 */
        promotions(){
            if(this.promInfo?.PromotionType==2){//第二份折扣
                if(this.foodNotOrdered?.length>0){
                    this.clearProm2ZK();
                    let zkPromotion=this.promInfo.SecondZkPromotion;
                    //满足活动方案的菜
                    let zkItemList=this.getZKPromotionItem(zkPromotion);
                    if(zkItemList.length>0){
                        if(zkPromotion.PromKindType==1 && zkPromotion.SecondZkPromotionConsumes.length>0){//按活动菜品范围打折 要求是同一种菜品
                            //按菜品id 分组
                            zkItemList.groupBy("EAT_XFBMID",(group)=>{
                                let num=0;
                                let itemList=[];//
                                group.forEach(it=>{
                                    let number=Math.floor(it.Eat_Number); 
                                    for(let i=0;i<number;i++){
                                        num++;
                                        if(num>1){
                                            if(zkPromotion.SecondZkPromotionConsumes.length>num-2){//活动第几个菜 可折
                                                itemList.push({index:num,item:it});
                                            }else{
                                                num=1;
                                            }
                                        }
                                    }
                                })
                                //倒序排序 插入数据时会按 第几个 折扣 在原数据后排列
                                itemList.reverse().forEach(item=>{
                                    this.addZKItem(item.item,zkPromotion.SecondZkPromotionConsumes[item.index-2]);
                                })
                            })
                        }else if(zkPromotion.PromKindType==2 || zkPromotion.PromKindType==3){//按指定菜品范围打折【优先价低者折扣】 只有在指定范围的菜能折扣
                            if(zkItemList.length>0){
                                let specifyFoods=[],zkSpecifyFoods=[];
                                zkPromotion.SpecifyFoods?.forEach(food=>{
                                    if(zkItemList.some(it=>it.EAT_XFBMID==food.Item_ID)){//拥有第二份折扣活动的菜 在 指定折扣菜中
                                        zkSpecifyFoods.push(food);
                                    }else{//排除拥有第二份折扣活动的菜
                                        specifyFoods.push(food);
                                    }
                                })
                                if(zkPromotion.PromKindType==2){//按指定菜品范围打折【优先价低者折扣】 
                                    //活动菜品 销售价倒序 当活动菜与指定菜相同时 即 价格最高的 被当成 活动菜，价格最低当成 指定折扣菜
                                    zkItemList.sort((d1,d2)=>d2.Eat_SalePrice-d1.Eat_SalePrice);
                                }else{//按指定菜品范围打折【优先价高者折扣】 
                                    //活动菜品 销售价顺序 当活动菜与指定菜相同时 即 价格最高的 被当成 指定折扣菜，价格最低当成 活动菜
                                    zkItemList.sort((d1,d2)=>d1.Eat_SalePrice-d2.Eat_SalePrice);//销售价 顺序
                                }
                                zkItemList.forEach(it=>{
                                    let number=it.Eat_Number-it._promotionNumber;
                                    //排除已经折扣 或 活动折扣剩余数量小于1
                                    if(!it.isPromotion2 && number>=1){
                                        for(let i=0;i<number;i++){
                                            if(it.Eat_Number-it._promotionNumber<1){
                                                break;
                                            }
                                            let itemList=this.getSpecifyItem(zkPromotion,specifyFoods,zkSpecifyFoods);
                                            if(itemList.length>0){
                                                // itemList.some(item=>{//多个 可折扣的 找到一个折扣即可
                                                    
                                                // })
                                                let item=itemList[0];
                                                if(item.Eat_ConsumeID==it.Eat_ConsumeID){//如果是自身
                                                    if(it.Eat_Number-it._promotionNumber>=2){//剩余可活动的菜 必须 大于等于2 满足第二份折扣
                                                        it._promotionNumber++;//记录 原活动菜品 已经使用了几次 折扣
                                                        this.addZKItem(item,zkPromotion.SecondZkPromotionConsumes[0]);
                                                    }else if(itemList.length>1){
                                                        let item=itemList[1];
                                                        if(item.Eat_SalePrice==it.Eat_SalePrice){
                                                            it._promotionNumber++;//记录 原活动菜品 已经使用了几次 折扣
                                                            this.addZKItem(item,zkPromotion.SecondZkPromotionConsumes[0]);
                                                        }
                                                    }
                                                }else{
                                                    it._promotionNumber++;//记录 原活动菜品 已经使用了几次 折扣
                                                    this.addZKItem(item,zkPromotion.SecondZkPromotionConsumes[0]);
                                                    //return true;
                                                }
                                            }
                                        }
                                        
                                    }
                                })
                            }
                        }
                    }
                }
            }
        },
        //返回折扣活动菜品
        getZKPromotionItem(zkPromotion){
            //排除 有其它活动的菜品、 加价口味作法 菜品数量必须大于等于1
            let list= (this.foodNotOrderedNoDiscount||[]).filter(item=>item.Eat_Number>=1)
            let zkItemList=[];
            if(zkPromotion.XfbmKind==1){//按菜品小类
                if(zkPromotion.SubFoodKinds?.length>0){
                    list.forEach(item=>{
                        if(zkPromotion.SubFoodKinds.some(it=>it.Item_ID== item.SubCategory_ID)){
                            zkItemList.push(item);
                        }
                    })
                }
            }else{/// =2 按菜品指定
                if(zkPromotion.Foods?.length>0){
                    list.forEach(item=>{
                        if(zkPromotion.Foods.some(it=>it.Item_ID== item.EAT_XFBMID)){
                            zkItemList.push(item);
                        }
                    })
                }
            }
            return zkItemList;
        },
        //返回指定菜品 进行折扣
        getSpecifyItem(zkPromotion,specifyFoods,zkSpecifyFoods){
            //排除 有其它活动的菜品、 加价口味作法 、排除当前拥有第二份折扣活动的菜
            let list=[];
            //排除 有其它活动的菜品、 加价口味作法
            let orderMenuList=(this.foodNotOrderedNoDiscount||[]).filter(item=>item.Eat_Number-item._promotionNumber>=1 && !item.isPromotion2 && item.Eat_Number>=1);
            
            orderMenuList.forEach(item=>{
                //排除拥有第二份折扣活动的菜、 查询指定要折扣的菜
                if(specifyFoods?.some(food=>food.Item_ID==item.EAT_XFBMID)){
                    list.push(item);
                }
            })
            if(list.length==0){
                orderMenuList.forEach(item=>{
                    //查询 拥有第二份折扣活动的菜 并且在是指定要折扣的菜
                    if(zkSpecifyFoods?.some(food=>food.Item_ID==item.EAT_XFBMID)){
                        list.push(item);
                    }
                })
            }

            if(list.length>0){
                if(zkPromotion.PromKindType==2){//按指定菜品范围打折【优先价低者折扣】 
                    list.sort((d1,d2)=>d1.Eat_SalePrice-d2.Eat_SalePrice);//销售价 顺序
                }else{//按指定菜品范围打折【优先价高者折扣】 
                    list.sort((d1,d2)=>d2.Eat_SalePrice-d1.Eat_SalePrice);//销售价 倒序
                }
            }
            return list;
        },
        //拆分 或 修改 菜品折扣
        addZKItem(item,zkConsume){
            if(item.Eat_Number==1){
                item.isPromotion2=true;
                //ReduceNum 优惠值 7折则为70
                item.zkPromotionPrice=Number((item.Eat_SalePrice* (zkConsume.ReduceNum/100)).toFixed(4));
            }else{//数量多个 进行拆分
                let _tempItem=deepClone(item);//复制原菜
                _tempItem.Eat_ConsumeID=newGuid();
                _tempItem.Eat_Number=1;
                _tempItem.FoodModifys=null;//清空口味作法
                _tempItem.Eat_MasName="";
                _tempItem.Is_Combo=false;//拆除组合菜
                _tempItem.Eat_TcAutoID_Batch=null;
                _tempItem.Eat_TcName=null;
                _tempItem.Eat_TcIndex=null;
                _tempItem.ModiPrice=0;
                _tempItem._promotionNumber=0;
                _tempItem.isPromotion2=true;
                _tempItem.zkPromotionPrice=Number((item.Eat_SalePrice* (zkConsume.ReduceNum/100)).toFixed(4));
                let EatNumber=item.Eat_Number;
                _tempItem.FoodSetmeals?.forEach(it=>{
                    it.Eat_ConsumeID=newGuid();
                    it.FoodModifys=null;//清空口味作法
                    it.Eat_MasName="";
                    it.ModiPrice=0;
                    it.FoodSetmeal_Number = Number((it.FoodSetmeal_Number / EatNumber).toFixed(4));//按比例 分配一份数量;
                })
               
                let is_taste=false;//原数据是否有口味加价做法
                //原数据减少一份
                item.Eat_Number--;
                this.parent.orderMenuList.forEach(or=>{
                    if(or.Eat_ConsumeID==item.Eat_ConsumeID && or.is_taste){
                        is_taste=true;
                        if(or.Price_Kind==0){
                            if(or.Eat_Number>1){
                                or.Eat_Number=Number((or.Eat_Number-1).toFixed(4));//加价口味做法 数量减一;
                            }
                        }
                    }
                })
                
                /**有口味 */
                if(item.FoodModifys){
                    item.FoodModifys.forEach(item=>{
                        if(item.Price_Kind==0){
                            if(item.Mas_Num>1){
                                item.Mas_Num= Number((item.Mas_Num-1).toFixed(4));//加价口味做法 数量减一
                            }
                        }
                    })
                }
                //套餐
                item.FoodSetmeals?.forEach(it=>{
                    let num=1;//套餐明细减少一份
                    if(it.FoodSetmeal_Number>1 && it.FoodSetmeal_Number>= EatNumber){
                        num = it.FoodSetmeal_Number / EatNumber;//按比例减少
                    }
                    it.FoodSetmeal_Number = Number((it.FoodSetmeal_Number-num).toFixed(4));

                    if(it.FoodModifys){//套餐明细 加价口味做法 数量 减少
                        let orNumber=0;
                        this.parent.orderMenuList.forEach(or=>{
                            if(or.Eat_ConsumeID==it.Eat_ConsumeID){
                                is_taste=true;
                                if(or.Price_Kind==0 && or.Eat_Number<=it.FoodSetmeal_Number){
                                    or.Eat_Number = it.FoodSetmeal_Number;
                                    orNumber = or.Eat_Number;
                                }else{
                                    if(or.Price_Kind==0){
                                        or.Eat_Number = Number((or.Eat_Number-num).toFixed(4));
                                        orNumber = or.Eat_Number;
                                    }
                                }
                            }
                        })
                        it.FoodModifys.forEach(item=>{
                            if(item.Price_Kind==0){
                                item.Mas_Num =orNumber;
                            }
                        })
                    }
                })

                let index=this.parent.orderMenuList.findIndex(it=>it.Eat_ConsumeID==item.Eat_ConsumeID);
                if(index>=0){
                    if(is_taste){
                        this.parent.orderMenuList.splice(index,0,_tempItem);
                    }else{
                        this.parent.orderMenuList.splice(index+1,0,_tempItem);
                    }
                    this.updateRadio();
                }
            }
        },
        /**满减 返回满减金额
        */
        fullReduction(){
            let youHuiMoney=0;//优惠金额
            let list=(this.foodNotOrdered||[]);
            if(list.length>0){
                list.forEach(it=>{
                    //满减 扣除 单价
                    it.fullReducePrice=0;
                    it.isFullReduce=false;
                });

                let toDay=new Date();//当前时间
                let time=toDay.Format("hh:mm");//时分
                let weekDay=toDay.getDay();//周
                if(weekDay==0){
                    weekDay=7;
                }
                let promotion=this.fullPomotionList?.find(it=>it.BeginTime<=time && it.EndTime>=time && it.WeekDay?.indexOf(weekDay)>=0);
                if(promotion){//满减活动
                    let offPromotion=promotion.MoneyOffPromotion;//活动方案
                    let total=this.getFullTotalMoney(offPromotion);
                    let money=total.totalMoney;
                    
                    // if(offPromotion.CheckMoneyType==1){//折后
                    //     total.totalMoney;
                    // }else{
                    //     money=total.saleTotalMoney;
                    // }
                    if(offPromotion.MoneyOffPromotionConsumes?.length>0){
                        if(offPromotion.PromKindType==2 || offPromotion.PromKindType==4){//只有一个
                            let consumes=offPromotion.MoneyOffPromotionConsumes[0];
                            if(consumes.FullMoney>0){//金额每满X元 减   要减的金额=向下取整(金额/每满金额)*减金额
                                youHuiMoney=Number((Math.floor(money/consumes.FullMoney)*consumes.ReduceMoney).toFixed(2));
                                if(youHuiMoney>consumes.MaxReduceMoney){//不能超过 最大优惠减金额
                                    youHuiMoney=consumes.MaxReduceMoney;
                                }
                            }
                        }else{//
                            let consumes=offPromotion.MoneyOffPromotionConsumes.find(it=>it.FullMoney<=money);
                            if(consumes){
                                if(consumes.FullMoney>=0){//按订单金额满x元减 
                                    youHuiMoney=consumes.ReduceMoney;
                                }
                            }
                        }  
                    }
                    // if(offPromotion.CheckMoneyType==0 && youHuiMoney>total.totalMoney){//如果折前金额 优惠力度大于 实际 结算金额 则优惠金额等于 结算金额
                    //     youHuiMoney=total.totalMoney;
                    // }
                    if(youHuiMoney>0){
                        if(total.saleTotalMoney>0){//按折前金额 计算 满减
                            let perReduce= youHuiMoney/total.saleTotalMoney;
                            total.fullItemList.forEach(it=>{
                                let money=  (it.Eat_SalePrice * it.Eat_Number)*(1-perReduce);
                                //满减 扣除 单价
                                it.fullReducePrice=Number((money/it.Eat_Number).toFixed(4));
                                it.isFullReduce=true;
                            })
                        }
                    }
                }
            }
            return youHuiMoney;
        },
        //按满减规则返回订单菜品
        getFullTotalMoney(offPromotion){
            //排除 有其它活动的菜品、 加价口味作法
            let list=(this.foodNotOrderedNoDiscount||[]).filter(item=>!item.isPromotion2 && item.Eat_Number>0);
            //如果有参加满赠 满赠活动菜要排除
            if(this.promInfo?.PromotionType==3){//满赠
                let RuleFoods=this.promInfo.MoneyGiftPromotion?.RuleFoods||[]//活动菜
                list=list.filter(item=>!RuleFoods.some(rule=>rule.Item_ID==item.EAT_XFBMID));
            }

            let totalMoney=0;//结算金额
            let saleTotalMoney=0;//销售金额
            let fullItemList=[];//需要满减的 明细数据
            //活动类型方式 //=1 按订单金额满x元 减 ///= 2 按订单金额每满X元 减 
            if(offPromotion.PromKindType==1 || offPromotion.PromKindType==2){ 
                //菜品有点菜数量
                list.forEach(item=>{
                    fullItemList.push(item);
                });
            }else{///= 3 按订单菜品满x元减 OR 赠///= 4 按订单菜品每满X元 减 OR 赠
                if(offPromotion.XfbmKind==1){//活动按菜品方式 /// =1 按菜品小类/// =2 按菜品指定
                    if(offPromotion.SubFoodKinds?.length>0){
                        list.forEach(item=>{
                            if(offPromotion.SubFoodKinds.some(it=>it.Item_ID== item.SubCategory_ID)){
                                fullItemList.push(item);
                            }
                        })
                    }
                }else{/// =2 按菜品指定
                    if(offPromotion.Foods?.length>0){
                        list.forEach(item=>{
                            if(offPromotion.Foods.some(it=>it.Item_ID== item.EAT_XFBMID)){
                                fullItemList.push(item);
                            }
                        })
                    }
                }
            }

            fullItemList.forEach(it=>{
                if(it.FoodSetmeals){//套餐
                    it.FoodSetmeals.forEach(food=>{
                        totalMoney=Number(food.FoodSetmeal_Price).compute(food.FoodSetmeal_Number,'*').compute(totalMoney) //结算总价格
                        saleTotalMoney=Number(food.FoodSetmeal_Price).compute(food.FoodSetmeal_Number,'*').compute(saleTotalMoney) //总价格
                    })
                }
                totalMoney = Number(it.Eat_CheckPrice).compute(it.Eat_Number,'*').compute(totalMoney)//结算总价格
                saleTotalMoney = Number(it.Eat_SalePrice).compute(it.Eat_Number,'*').compute(saleTotalMoney)  //总价格
            })
            return {
                //销售总金额
                saleTotalMoney:Number(saleTotalMoney.toFixed(2)),//保留两位小数
                //结算总价格
                totalMoney: Number(totalMoney.toFixed(2)),//保留两位小数
                fullItemList:fullItemList
            } 
        },
        /**
         * 满赠计算
         */
        fullGiveProm(items){
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            //先删除之前加入的满赠
            for(let i=0;i<this.parent.orderMenuList.length;i++){
                let food=this.parent.orderMenuList[i];
                if(food.Food_Status==-1 && !food.is_taste && food.isFullGive){//满赠的菜品
                    if(!items || !items.some(m=>m.Food_ID==food.EAT_XFBMID)){
                        this.deleteFood(food);
                        i--;
                    }
                }
            }
            if(items?.length>0){
                items?.forEach(it=>{
                    let food=this.parent.orderMenuList.find(food=>food.Food_Status==-1 && !food.is_taste && food.isFullGive && food.EAT_XFBMID==it.Food_ID);
                    if(food){
                        if(food.Eat_Number!=it.number){
                            this.setFoodNumber(food,it.number);
                        }
                    }else{
                        let _item=this.getFoodChildren(it);
                        _item.ConsumeOperations=[{
                            OperateType:8,//满赠优惠
                            OperateReason:"",
                            Operator:userInfo?.Login_Name,
                            Project_AutoID:'',Project_Name:'',Project_Kind:0,Project_Rate:0,Old_Price:it.Eat_SalePrice
                        }];
                        _item.Eat_Number=it.number;
                        _item.FoodDiscount_Dimension="赠";
                        _item.Eat_CheckPrice = 0;
                        _item.Is_Gift = true;
                        _item.isFullGive=true;//满赠的菜品 
                        this.parent.orderMenuList.push(_item);
                    }
                })
                this.parent.clickEndConsume();
            }
        },
        /**当前 满赠活动 最大可赠送数量变化了 重新计算赠送的菜*/
        setPromMaxGitNum(){
            if(this.foodNotOrdered.length>0){
                this.clickPromotional();
            }
            // let totalNum=0;
            // //先删除之前加入的满赠
            // for(let i=0;i<this.parent.orderMenuList.length;i++){
            //     let food=this.parent.orderMenuList[i];
            //     if(food.Food_Status==-1 && !food.is_taste && food.isFullGive){//满赠的菜品
            //         if(Number(food.Eat_Number).compute(totalNum)>this.promMaxGitNum){
            //             let num= Number(food.Eat_Number).compute(totalNum,-this.promMaxGitNum);
            //             if(food.Eat_Number>num){
            //                 this.setFoodNumber(food,num);
            //             }else{
            //                 this.deleteFood(food);
            //                 i--;
            //             }
                        
            //         }else{
            //             totalNum=Number(food.Eat_Number).compute(totalNum);
            //         }
            //     }
            // }
        },
        /**修改 购物车菜品 数量 */
        setFoodNumber(item,Eat_Number){
            this.parent.orderMenuList.forEach(order=>{
                if(order.Eat_ConsumeID==item.Eat_ConsumeID){
                    if(order.Price_Kind!=1 && order.Price_Kind!=2){//按量加价口味做法数量 或 单菜品数量
                        order.Eat_Number=Eat_Number;
                    }
                    if(order.FoodModifys){//口味做法 数量更新
                        order.FoodModifys.forEach(item=>{
                            if(item.Price_Kind==0){
                                item.Mas_Num=Eat_Number;
                            }
                        })
                    }
                }
            });
        },
        /**删除一个购物车中的菜品 单菜*/
        deleteFood(item){
            let arr=[];
            this.parent.orderMenuList.forEach(order=>{
                //过滤 要删除的菜品 
                if(order.Eat_ConsumeID!=item.Eat_ConsumeID){
                    //要删除组合菜品下的菜品
                    if(item.OrderComboConsumes?.some(it=>it.Eat_ConsumeID==order.Eat_ConsumeID)){
                        return;
                    }
                    arr.push(order)
                }
            })
            if(item?.FoodSetmeals){
                for(let i=0; i<arr.length; i++){
                    item.FoodSetmeals.forEach(food=>{
                        if(food.Eat_ConsumeID==arr[i]?.Eat_ConsumeID){
                            arr.splice(i,1)
                            i--;
                        }
                    })
                }
            }
            this.parent.orderMenuList = arr;
            this.parent.clickEndConsume(this.disRadioclass);
        },
        /**点击 参与优惠活动 */
        clickPromotional(){
            if(this.promInfo && this.promInfo.PromotionType==3){//满赠
                if(this.promInfo.promGiveItems.length>0){
                    let orderMenuList=this.parent.orderMenuList;
                    //过滤 被删除的赠送的菜
                    this.promInfo.promGiveItems=this.promInfo.promGiveItems.filter(it=>orderMenuList.some(food=>food.Food_Status==-1 && !food.is_taste && food.isFullGive && food.EAT_XFBMID==it.Food_ID));
                }
                this.promotionalGiveShow=true;
            }else{
                this.promotionalData=Object.assign([],this.promList);
                this.promotionalSelectShow=true;
            }
        },
        /**点击确认优惠活动 */
        confirmProm(promInfo){
            if(this.promInfo?.PromotionType==2){//第二份折扣
                this.clearProm2ZK();
            }
            //当前参加的优惠活动
            this.promInfo=promInfo;
            this.promotionalSelectShow=false;
            if(this.promInfo.PromotionType==3){//选择满赠活动时
                this.promInfo.promGiveItems=[];//选择赠送的菜品
                this.promotionalGiveShow=true;
            }else if(this.promInfo.PromotionType==2){//是否第二份 折扣
                this.promotions();
            }
        },
        /**点击取消优惠活动 */
        cancelProm(){
            if(this.promInfo?.PromotionType==2){//第二份折扣
                this.clearProm2ZK();
            }
            //当前参加的优惠活动
            this.promInfo=null;
            this.promotionalSelectShow=false;
            
        },
        /**满赠 点击确认 */
        confirmPromGive(items){
            //未下单 非满赠的菜品
            let foods=this.parent.orderMenuList.filter(food=>food.Food_Status==-1 && !food.is_taste && !food.isFullGive)

            try {
                items.forEach(item=>{
                    if(item.Is_Limited && item.RemainNum>0 && item.Is_LimitedProject){
                        let _RemainNum=0;
                        foods.forEach(order=>{
                            if(order.EAT_XFBMID==item.Food_ID && order.Eat_Number>0){
                                _RemainNum = Number(order.Eat_Number).compute(_RemainNum);
                            }
                        })
                        let remainNum=Number(item.RemainNum).compute(-_RemainNum);//剩余可点数量
                        if(Number(item.number)>remainNum){
                            throw {message:`【${item.Food_Name}】剩余${remainNum}份,赠送${item.number}份,超过了当前剩余数量`};
                        }
                    }
                })
            } catch (error) {
                this.$message.warning(error.message);
                return;
            }

            this.promInfo.promGiveItems=items;
            this.promotionalGiveShow=false;
            this.fullGiveProm(items);
        },
        /**满赠 放弃优惠并返回 */
        cancelPromGive(){
            //清除满赠的菜
            this.fullGiveProm();
            this.promInfo=null;
            this.promotionalGiveShow=false;
        },
        /**组装 加入购物车的菜品格式 */
        getFoodChildren(item){
            let _item ={
                Eat_ConsumeID:newGuid(),
                SubCategory_ID:item.SubCategory_ID,
                EAT_XFBMID:item.Food_ID,
                EAT_XFCode:item.Food_Code,
                EAT_XFName:item.Food_Name,
                Eat_Number:1,
                Eat_CheckPrice:item.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:item.Food_Price,
                Food_CostPrice:item.Food_CostPrice,//成本金额
                Eat_MasName:'',
                Food_Status:-1,
                Food_AssSize:item.Food_AssSize,
                AssSizeNumber:'',
                Eat_XFSize:item.Food_Size,
                FoodModifys:null,
                FoodSetmeals:null,
                Is_Special:item.Is_Special,//是否是推荐菜
                Is_Discounted:item.Is_Discounted,
                Is_Seasonal:item.Is_Seasonal,
                RemainNum:item.RemainNum,
                Is_Limited:item.Is_Limited,
                Is_ChangedNum:item.Is_ChangedNum,
                Is_ChargeForService:item.Is_ChargeForService,
                Is_SetMeal:item.Is_SetMeal,
                OnlySupportIntNum:item.OnlySupportIntNum,//是否数量取整
                Promotion_Price:0,
                ConsumeOperations:[]
            };
            return _item
        }
    },
}
</script>

<style lang="scss">
.orderMenuBox{
    .promotionalOffer-box{
        padding:8px;
        background: #FFE4E4;
        font-weight: 500;
        font-size: 12px;
        color: #CA2929;
        display: flex;
        align-items: center;

        .text{
            flex:1;
        }

        .promotionalBnt{
            min-width: 60px;
            height: 24px;
            line-height:24px;
            text-align: center;
            padding: 0 6px;
            background: #E24F4F;
            border-radius: 4px;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            cursor: pointer;
        }
    }
}
</style>